module.exports = __webpack_public_path__ + "img/cat-12.ab6d7298.png";